import * as React from 'react'

export interface CheckboxProps {
    label?: string
    children?: React.ReactNode
    value: boolean
    onChange: (e: any) => void
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, children, value, onChange, ...props }, ref) => {
        const inputClasses = [
            'h-5 w-5 bg-gray',
            'border-0 rounded',
            'checked:bg-blue',
            'focus:outline-none focus:ring-black',
        ].join(' ')

        return (
            <label className='flex items-center space-x-3'>
                <input
                    ref={ref}
                    type='checkbox'
                    className={inputClasses}
                    checked={value}
                    onChange={onChange}
                />
                <span className='text-gray'>
                    {label}
                    {children}
                </span>
            </label>
        )
    },
)
